import {inject} from '@angular/core';
import {TranslateService as RuntimeTranslateService} from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import {Session} from "../../../../models/session.model";
import Swal from "sweetalert2";
import {Groupe} from "../../../../models/groupe.model";
import {CatalogueService} from "../../../../services/catalogue.service";
import {SessionService} from "../../../../services/session.service";
import {FormArray, UntypedFormBuilder, FormControl} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {Catalogue} from "../../../../models/catalogue.model";
import {ConfigService} from "../../../../services/config.service";


@Component({
    selector: 'app-edit-catalogue-session',
    templateUrl: './edit-catalog-management.component.html',
    styleUrls: ['./edit-catalog-management.component.css'],
    standalone: false
})
export class EditCatalogManagementComponent implements OnInit {
  private readonly runtimeTranslate = inject(RuntimeTranslateService);

  constructor(private catalogueService: CatalogueService,
              private sessionService: SessionService,
              private activatedRoute: ActivatedRoute,
              private configService: ConfigService,
              private formBuilder: UntypedFormBuilder,
              private router: Router) { }

  //Initialisation
  Catalogue = new Catalogue();
  CatalogueOlder = new Catalogue();

  public profile_id = parseInt(localStorage.getItem('profile_id'));
  //create ChoiceScreen
  responseMessage : string;

  ngOnInit() {
    this.ShowChoiceScreen(this.activatedRoute.snapshot.url[4].path)
  }


  ShowChoiceScreen(id) {
    this.catalogueService.getCatalogue(id)
      .subscribe(res => {
        this.Catalogue = res.catalogue;
        this.CatalogueOlder = { ...res.catalogue };
      }, (err) => {
        Swal.fire(
          this.runtimeTranslate.instant('alerts.error'),
          this.runtimeTranslate.instant('alerts.loadingInfoError'),
          'error'
        );
      });
  }

  //UPDATE Catalogue
  updateCatalogue(id) {
    // tslint:disable-next-line:max-line-length
    if (this.Catalogue.titre === undefined || this.Catalogue.titre.trim() === '') {
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.oops'),
        text: this.runtimeTranslate.instant('messages.titleMissing')
      });
      return false;
      // tslint:disable-next-line:align
    }
    else if (this.Catalogue.description === undefined || this.Catalogue.description.trim() === '') {
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.oops'),
        text: this.runtimeTranslate.instant('messages.descriptionRequired'),
      });
      return false;
      // tslint:disable-next-line:align
    }
    else if (this.CatalogueOlder.titre == this.Catalogue.titre
      && this.CatalogueOlder.description == this.Catalogue.description
      && this.CatalogueOlder.langue == this.Catalogue.langue
    ) {
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.oops'),
        text: this.runtimeTranslate.instant('messages.noChanges'),
      });
      return false;
    }
    else{
      const body = {
        titre: this.Catalogue.titre,
        description: this.Catalogue.description,
        langue : this.Catalogue.langue,
      };
      this.catalogueService.editCatalogue(id,body)
        .subscribe(res => {
          if(res.success == false){
            Swal.fire({
              icon: 'error',
              title: this.runtimeTranslate.instant('alerts.oops'),
              text: res.message
            });
          }
          else{
            // @ts-ignore: Unreachable code error
            this.Catalogue.titre = '';
            this.Catalogue.description = '';
            Swal.fire({
            title: this.runtimeTranslate.instant('alerts.catalogUpdated'),
            text: res.message,
            icon: 'success',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.runtimeTranslate.instant('alerts.backToCatalogs'),
            cancelButtonText: this.runtimeTranslate.instant('alerts.stayOnPage')
          }).then((result) => {
            if (result.isConfirmed) {
              this.router.navigate(['/dashboard/administrator/catalogue-management']);
            }
            else{
              window.location.reload();
              this.ShowChoiceScreen(this.activatedRoute.snapshot.url[4].path);
            }
          });
        }}, (err) => {
          Swal.fire({
            icon: 'error',
            title: this.runtimeTranslate.instant('alerts.oops'),
            text: this.responseMessage
          });
        });
    }
  }



}
